import Vue from 'vue'
import vueNotification from 'vue-notification'

Vue.use(vueNotification)

export default {}
